import { catalogItem } from '../config/catalog';
import { slotById } from '../config/map';
import { t } from '../i18n';
import { storageCap } from '../sim/economy';
import { entityAtSlot, isParcelUnlocked } from '../sim/park';
import { plotIdForLegacyCell } from '../spatial/buildableArea';
import type { ParkState, PlacedEntity } from '../types';

export type ProductionSlotOpen =
  | { kind: 'unknown' }
  | { kind: 'expand'; parcelId: string }
  | { kind: 'entity'; entity: PlacedEntity }
  | { kind: 'build'; slotId: string };

export interface EntityPanelIncomeView {
  collectible: boolean;
  storedCoins: number;
  storageCap: number;
  storedText: string;
  collectLabel: string;
  collectEnabled: boolean;
}

/** Occupied-slot click inspects only. Never collects. */
export function resolveProductionSlotOpen(state: ParkState, slotId: string): ProductionSlotOpen {
  const slot = slotById(slotId);
  if (!slot) {
    return { kind: 'unknown' };
  }
  const plotId = plotIdForLegacyCell(slot.col, slot.row);
  if (!isParcelUnlocked(state, plotId)) {
    return { kind: 'expand', parcelId: plotId };
  }
  const entity = entityAtSlot(state, slotId);
  if (entity) {
    return { kind: 'entity', entity };
  }
  return { kind: 'build', slotId };
}

export function entityPanelIncomeView(entity: PlacedEntity): EntityPanelIncomeView {
  const collectible = catalogItem(entity.kind).role !== 'decoration';
  const storedCoins = Math.floor(entity.storedCoins);
  const cap = storageCap(entity);
  return {
    collectible,
    storedCoins,
    storageCap: cap,
    storedText: collectible ? t('note.stored', { n: storedCoins, cap }) : t('note.decoration'),
    collectLabel: storedCoins >= 1 ? t('action.collectN', { n: storedCoins }) : t('action.collect'),
    collectEnabled: collectible && storedCoins >= 1,
  };
}
